import { boot } from 'quasar/wrappers'
import axios from 'axios'
import Notify from 'quasar/src/plugins/Notify.js';
import { i18n } from 'boot/i18n'
import { isSubscriptionBlocked } from 'src/helpers/subscription'

export const nsApi = axios.create({ baseURL: process.env.NS_DOMAIN })
export const api = axios.create({ withCredentials: true, withXSRFToken: true })

export async function getBaseUrlFromPiva(piva) {
  const { data } = await nsApi.post('/', { piva, app: process.env.URI })
  return data
}

export default boot(async ({ Vue, store, router }) => {
  await store.dispatch('tenant/init')

  api.interceptors.request.use(config => ({
    ...config,
    baseURL: store.getters['tenant/url'],
  }), error => Promise.reject(error))

  // stato del canone: header presenti solo in tolleranza, assenti con stato attivo
  const readSubscriptionHeaders = ({ headers }) => store.commit('subscription/setStatus', {
    status: headers['x-subscription-status'],
    validUntil: headers['x-subscription-valid-until'],
  })

  api.interceptors.response.use(response => {
    readSubscriptionHeaders(response)
    return response
  }, async error => {
    if (isSubscriptionBlocked(error)) {
      store.commit('subscription/setBlocked', {
        message: error.response.data.message,
        hasSession: !['login', 'token'].includes(error.config.url),
      })
      // prima della navigazione iniziale ci pensa la guard in boot/auth
      router.currentRoute.matched.length > 0 && router.currentRoute.path !== '/402' && router.push('/402').catch(() => {})
      throw error
    }
    error.response && readSubscriptionHeaders(error.response)

    // if (!axios.isAxiosError<{ message: string; errors: Record<string, string[]> }>(error) || !error.response) {
    if (!axios.isAxiosError(error) || !error.response) {
      if (error.name !== 'InvalidTenant') Notify.create({ type: 'negative', message: i18n.t('server_unreachable') })
    } else if (![422, 404].includes(error.response.status) && store.state.apis.finish) {
      const message = error.response.data.message ? i18n.t('attention') : i18n.t('something_went_wrong')
      const caption = (error.response.data instanceof Blob
        ? JSON.parse(await error.response.data.text()).message
        : error.response.data.message) || i18n.t('something_went_wrong_description')

      Notify.create({ type: error.response.status === 422 ? 'warning' : 'negative', message, caption })
    }

    throw error
  })

  Vue.prototype.$ax = api
})
